import React from 'react';
import styles from './FloTextArea.module.css';
import classnames from 'classnames';
import { FloComponentProps } from 'components';
import { Form } from 'react-bootstrap';

interface FloTextAreaProps extends FloComponentProps {
  placeholder?: string;
  onChange?:    any;
  onBlur?:      any;
  value:        string;
  isInvalid?:   boolean;
  disabled?:    boolean;
  rows?:        number;
}

export const FloTextArea: React.FC<FloTextAreaProps> =  React.memo(({className, isInvalid, rows, ...props}) => {
  return (
    <Form.Control
      {...props}
      type="text"
      as="textarea"
      rows={rows || 1}
      isInvalid = {isInvalid}
      className = {classnames(styles.root, className, {[styles.invalid]: isInvalid})}
    />
  );
});

export default FloTextArea;
